import { registerSW } from "virtual:pwa-register";

import { cleanupOutdatedVisitedIslandCaches } from "./cleanupIslandCaches";
import type { RegisterPwaServiceWorker } from "./types";

const UPDATE_CHECK_INTERVAL_MS = 60_000;

export const registerPwaServiceWorker: RegisterPwaServiceWorker = (callbacks) => {
  void cleanupOutdatedVisitedIslandCaches().catch(() => undefined);

  let registration: ServiceWorkerRegistration | undefined;
  let lastUpdateCheckAt = Number.NEGATIVE_INFINITY;
  let pendingUpdateCheck: Promise<void> | null = null;
  const checkForUpdate = (force = false): Promise<void> => {
    if (registration === undefined) {
      return Promise.resolve();
    }

    const now = Date.now();
    if (!force && now - lastUpdateCheckAt < UPDATE_CHECK_INTERVAL_MS) {
      return Promise.resolve();
    }
    if (pendingUpdateCheck !== null) {
      return pendingUpdateCheck;
    }

    lastUpdateCheckAt = now;
    const updateCheck = registration.update().then(() => undefined).finally(() => {
      pendingUpdateCheck = null;
    });
    pendingUpdateCheck = updateCheck;
    return updateCheck;
  };

  const applyUpdate = registerSW({
    immediate: true,
    onNeedReload: callbacks.onNeedRefresh,
    onNeedRefresh: callbacks.onNeedRefresh,
    onOfflineReady: callbacks.onOfflineReady,
    onRegisteredSW: (_scriptUrl, nextRegistration) => {
      registration = nextRegistration;
      void checkForUpdate(true).catch(() => undefined);
    },
    onRegisterError: callbacks.onRegisterError
  });

  return {
    applyUpdate: () => applyUpdate(false),
    checkForUpdate
  };
};
